export const formatDateDDMMYYYDotted = (date: any) => {
  if (date) {
    const newDate = new Date(date);
    const year: any = newDate.getFullYear();
    let month: any = newDate.getMonth() + 1;
    let dt: any = newDate.getDate();
    if (dt < 10) {
      dt = `0${dt}`;
    }
    if (month < 10) {
      month = `0${month}`;
    }
    return `${dt}.${month}.${year}`;
  }
  return date;
};

export const convertEPOCToISO = (date: any) => {
  if (date) {
    const newDate = new Date(date * 1000);
    return newDate.toISOString();
  }
  return date;
};

export const convertEPOCToDate = (date: any) => {
  if (date) {
    const newDate = new Date(date * 1000);
    return newDate;
  }
  return date;
};

// '2023-01-11' -> 1673395200
export const dateToTimestamp = (date: any) => {
  if (date) {
    const newDate = parseInt((new Date(date).getTime() / 1000).toFixed(0));
    return newDate;
  }
  return date;
};

export const dateInPast = (firstDate: Date, secondDate: Date) => {
  if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
    return true;
  }
  return false;
};

export const treatAsUTC = (date: Date): any => {
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date;
};

export const daysBetween = (startDate: Date, endDate: Date) => {
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const endDateAdjusted = new Date(endDate);
  endDateAdjusted.setHours(23, 59, 59);
  return Math.ceil((treatAsUTC(new Date(endDateAdjusted)) - treatAsUTC(startDate)) / millisecondsPerDay);
};

export const dateInFuture = (date: Date) => {
  if (date) {
    const now = new Date();
    const compare = new Date(date);
    return compare > now;
  } else {
    return false;
  }
};

export const getDate = (
  date: number,
  separator: string = ' ',
  monthFormat: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow' | undefined = 'long',
  showYear: boolean = true
) => {
  const formattedDate = new Date(date * 1000);
  try {
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(formattedDate);
    const mo = new Intl.DateTimeFormat('en', { month: monthFormat }).format(formattedDate);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(formattedDate);

    return `${da}${separator}${mo}${showYear ? separator + ye : ''}`;
  } catch (err) {
    return null;
  }
};

export const formatCountdown = (ISOString: string, fulldate?: any) => {
  if (!ISOString) return undefined;

  const date = new Date(ISOString);
  const today = new Date();

  const options: Intl.DateTimeFormatOptions = {};
  const difference = today.valueOf() - date.valueOf();
  const differenceInDays = difference / (1000 * 3600 * 24);

  // Determine the format based on difference in days
  switch (true) {
    case differenceInDays < 1: // Less than 24 hours
      options.hour = 'numeric';
      options.minute = 'numeric';
      break;

    case differenceInDays < 8: // Less than 1 week
      options.weekday = 'short';
      break;

    default: // Otherwise (more than 1 week)
      options.day = 'numeric';
      options.month = 'long';
      break;
  }

  // If fulldate is provided, show full date
  if (fulldate) {
    options.timeZone = 'UTC';
    options.day = 'numeric';
    options.month = 'short';
    options.year = 'numeric';
  }

  return `${date.toLocaleString('en-UK', options)}`;
};
